"use strict";
import React from "react";
import classNames from "classnames";
import EmptyStateBlocks from "./EmptyStateBlocks";
import { Heading } from "../Heading";
import { Text } from "../Text";
const BASE_CLASS_NAME = "empty-state";
const EmptyState = ({ title, subtitle, isDashed, image, children, ...rest }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classNames(BASE_CLASS_NAME, { [`${BASE_CLASS_NAME}--dashed`]: isDashed }), ...rest }, /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__content` }, image ? image : /* @__PURE__ */ React.createElement(EmptyStateBlocks, { className: `${BASE_CLASS_NAME}__image` }), /* @__PURE__ */ React.createElement(Heading, { strong: true, level: "4", align: "center", className: `${BASE_CLASS_NAME}__title` }, title), /* @__PURE__ */ React.createElement(Text, { align: "center" }, subtitle)), children);
};
export default EmptyState;
